(function (w, d, $) {
  const accordeonsGroup = d.querySelectorAll('.js-tabs-additional-accordeon');

  $(accordeonsGroup).each(function () {
    const accordeons = $(this).children();
    accordeons.each(function () {
      const self = this.querySelector('.js-tabs-additional-accordeon');
      const btn = getButton(self);
      let isOpen = btn.hasClass('is-open');

      if (isOpen) {
        self.style.height = 'auto';
      }

      $(btn).on('click', function () {
        isOpen = !isOpen;

        if (isOpen) {
          $(accordeons).each(autoClose);
          $(this).addClass('is-open');
          TweenLite.set(self, { height: 'auto' });
          TweenLite.from(self, 0.6, { height: 0, ease: Expo.easeOut });
        } else {
          $(this).removeClass('is-open');
          TweenLite.to(self, 0.6, { height: 0, ease: Expo.easeOut });
        }
      });
    });
  });

  /**
   * Autoclose other accordions.
   * @returns {void}
   */
  function autoClose() {
    const self = this.querySelector('.js-tabs-additional-accordeon');
    const btn = getButton(self);
    if (btn.hasClass('is-open')) {
      btn.trigger('click');
    }
  }

  /**
   * Get the button of accordion.
   * @param {HTMLElement} element HTML parent element.
   * @returns {string}
   */
  function getButton(element) {
    return $(element).parent().find('.js-tabs-additional-accordeon-btn');
  }
})(window, document, jQuery);
